import React, { useState, Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Products from './components/Products';
import CTA from './components/CTA';
import Footer from './components/Footer';
import { ErrorBoundary } from './components/ErrorBoundary';
import { LoadingSpinner } from './components/LoadingSpinner';

// Lazy load ProductDetail
const ProductDetail = React.lazy(() => import('./pages/ProductDetail'));

function App() {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Router>
      <ErrorBoundary>
        <div className="min-h-screen bg-[#FAFAFA]">
          <Header 
            isMobileMenuOpen={isMobileMenuOpen}
            setIsMobileMenuOpen={setIsMobileMenuOpen}
          />
          <Routes>
            <Route path="/" element={
              <main>
                <Hero />
                <Products />
                <CTA />
              </main>
            } />
            <Route path="/product/:id" element={
              <Suspense fallback={<LoadingSpinner />}>
                <ProductDetail />
              </Suspense>
            } />
          </Routes>
          <Footer />
        </div>
      </ErrorBoundary>
    </Router>
  );
}

export default App;